export const browserDownloadFile = (url) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const hiddenIFrameID = 'hiddenDownloader' + Math.random();
  const iframe = document.createElement('iframe');
  iframe.id = hiddenIFrameID;
  iframe.style.display = 'none';
  document.body.appendChild(iframe);
  iframe.src = url + `?token=${user.token}`;
}
